export function extractExpression (field) {
  const doubleCurlyBracesRegExp = /\{\{([^}]+)\}\}/g

  const result = [...field.matchAll(doubleCurlyBracesRegExp)]

  return result
}
